module.exports = {
    install: function (Vue, options) {
        Vue.component('txt', require('./components/form/text.vue').default);
        Vue.component('company', require('./components/autocomplete/company.vue').default);
        Vue.component('list', require('./components/form/list.vue').default);

        Vue.prototype.currentLocation = '';
        Vue.prototype.$eventHub = new Vue();
        // == Translate Text into string == //
        Vue.prototype.trans = function (string) {
            // Find the Language entry for the Label
            if (string !== '' && typeof window.lang !== 'undefined' && typeof window.lang[string] !== 'undefined') {
                return window.lang[string];
            }
            return string.replace('_', ' ');
        };
        Vue.prototype.ifInternal = () => {
            return window.isInternal === '1';
        };
        Vue.prototype.findElementId = function (arr, propName, propValue) {
            for (let i=0; i < arr.length; i++) {
                if (arr[i][propName] === propValue) {
                    return i;
                }
            }
            return false;
        };
        Vue.prototype.uniqueid = function () {
            // always start with a letter (for DOM friendlyness)
            let idstr=String.fromCharCode(Math.floor((Math.random()*25)+65));
            do {
                // between numbers and characters (48 is 0 and 90 is Z (42-48 = 90)
                let ascicode=Math.floor((Math.random()*42)+48);
                if (ascicode<58 || ascicode>64){
                    // exclude all chars between : (58) and @ (64)
                    idstr+=String.fromCharCode(ascicode);
                }
            } while (idstr.length<32);

            return (idstr);
        };
        // == Store a model to a url and handle the logic == //
        Vue.prototype.$store = function (url, vm) {
            let model = vm;
            let name = '';
            if (typeof vm['model'] !== 'undefined') {
                model = vm.model;
            }
            if (typeof vm['name'] !== 'undefined') {
                name = vm.name;
            }
            this.$eventHub.$emit('saving' + name, true);
            if (typeof model.modal !== 'undefined' && model.modal == '#request_domain') {
                // only hide the set live modal
                hideModal(model.modal);
            }
            if (typeof model.loader !== 'undefined') {
                this.$root.toggleLoader(true);
            }
            if (typeof model.closeDialog !== 'undefined') {
                this.$eventHub.$emit('removeDialog', name);
            }

            this.axios.post(url, model).then((response) => {
                this.$root.toggleLoader(false);
                // handle response logic here
                let data = response.data;

                if (typeof model.preventDialogClose === 'undefined') {
                    this.$eventHub.$emit('removeDialog', name);
                    this.$eventHub.$emit('saving' + name, false);
                }
                if (typeof data.events !== 'undefined') {
                    this.$root.pushEvents(data.events);
                }

                if (typeof model.loader !== 'undefined' && model.loader) {
                    this.$root.toggleLoader(false);
                }
                if (typeof model.modal !== 'undefined' && model.modal) {
                    hideModal(model.modal);
                }
                if (typeof data.success !== 'undefined' && data.success && data.success !== 'true') {
                    this.$eventHub.$emit('latest-notif', {
                        title: data.success,
                        timeout: true
                    });
                }
                if (typeof data.type !== 'undefined' && typeof data.message !== 'undefined') {
                    this.$eventHub.$emit('latest-notif', {
                        title: data.message,
                        timeout: true
                    });
                }
                if (typeof data.url !== 'undefined' && data.url != false) {
                    window.location = data.url;
                }
                if (typeof data.refresh !== 'undefined' && data.refresh) {
                    this.$eventHub.$emit(data.refresh);
                }
                if (typeof data.closePanel !== 'undefined' && data.closePanel) {
                    this.$eventHub.$emit('closeRightPanel');
                }
                if (typeof vm.callback === 'function') {
                    vm.callback(data);
                }
            }).catch((error) => {
                this.$root.toggleLoader(false);
                this.$eventHub.$emit('saving' + name, false);
                if (typeof error.response === 'undefined') {
                    console.log(error);
                    return;
                }
                let data = error.response.data;

                // == Handle Validation Errors == //
                if (error.response.status === 422 && typeof data.errors !== 'undefined') {
                    // Keep Dialog open for validation failure
                    this.$eventHub.$emit('emitErrors', data);
                    return;
                } else {
                    this.$eventHub.$emit('removeDialog', name);
                }

                if (typeof model.loader !== 'undefined' && model.loader) {
                    this.$root.toggleLoader(false);
                }
                let title = 'Sorry, there was an error.';
                if (typeof data.title !== 'undefined') {
                    title = data.title;
                }
                myAlert({
                    heading: title,
                    message: data.error
                });
            });
        };
        // == Update a components model object == //
        Vue.prototype.$setData = function (data, model, defaultModel) {
            $.each(model, function (key, value) {
                let val = '';
                // If there is a default set of data, use that
                if (typeof defaultModel !== 'undefined' && typeof defaultModel[key] !== 'undefined') {
                    val = defaultModel[key];
                }
                if (typeof data[key] !== 'undefined') {
                    val = data[key];
                }
                model[key] = val;
            });
            return model;
        };
    }
};